export default __webpack_public_path__ + "static/media/pi-ico-active.7a0e4111.svg";